import { Component, OnInit } from '@angular/core';
import { IUser } from '../../../../shared/models/user';
import { ActivatedRoute } from '@angular/router';
import { IecBallotService } from '../../shared/services/iec-ballot.service';
import { IIecBallotDetails } from '../../shared/models/iec/iec-ballot-details';
import { filter, Subscription, take } from 'rxjs';
import { IBallotInternalHistory } from '../../shared/models/ballot-internal-history/ballot-internal-history';
import { IIecBallotSummary } from '../../shared/models/iec/iec-ballot-summary';
import { UnifiedBallotStatus } from '../../../../shared/enums/unified-ballot-status-enum';
import { AuthService } from '../../../../shared/services/auth.service';
import { UserUtility } from '../../../../shared/utilities/user-utility';
import { ITab } from '../../../controls/tab/tab.component';
@Component({
    selector: 'app-iec-details',
    templateUrl: './iec-details.component.html',
    styleUrl: './iec-details.component.scss',
    standalone: false
})
export class IecDetailsComponent implements OnInit {
  currentUser: IUser | null = null;
  loading: boolean = true;
  iecBallotDetail: IIecBallotDetails | null = null;
  selectedTab: string = '';
  initialTabId: string = 'ballotSummary';
  ballotInternalHistories: IBallotInternalHistory[] = [];
  isInternalUser: boolean = false;
  visibleTabs: ITab[] = [
    { id: 'ballotSummary', label: 'Ballot Summary' },
    { id: 'viewVotes', label: 'View Votes' },
  ];
  subscriptions: Subscription = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private _IecBallotService: IecBallotService,
    public _authService: AuthService
  ) {
    this.initUser();
  }

  initUser() {
    const currentUserSubscription = this._authService.currentUserSubject
      .pipe(
        filter((user) => !!user),
        take(1)
      )
      .subscribe((user) => {
        this.currentUser = user;
        this.isInternalUser = UserUtility.isInternalUser(user!);
        this.updateVisibleTabs();
      });
    this.subscriptions.add(currentUserSubscription);
  }

  ngOnInit(): void {
    this.route?.params?.subscribe((params) => {
      const id = params['id'];
      if (id) {
        this.getIECBallot(id);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onTabChange(tabId: string) {
    this.selectedTab = tabId;
  }

  private updateVisibleTabs(): void {
    const isFinalised =
      this.iecBallotDetail?.ballotSummary?.statusName?.toLowerCase() ===
      UnifiedBallotStatus[UnifiedBallotStatus.finalised];

    this.visibleTabs = [
      { id: 'ballotSummary', label: 'Ballot Summary' },
      { id: 'viewVotes', label: 'View Votes' },
      ...(this.isInternalUser && isFinalised
        ? [{ id: 'internalHistory', label: 'Internal History' }]
        : []),
    ];
  }

  private getIECBallot(ballotId: string): void {
    this._IecBallotService.getIECBallot(ballotId).subscribe(
      (response) => {
        if (response)
          if (response.success) {
            this.iecBallotDetail = response.content;
            this.ballotInternalHistories = this.generateBallotInternalHistory(
              this.iecBallotDetail.ballotSummary
            );
            this.updateVisibleTabs();
            this.loading = false;
          }
      },
      (error) => {
        console.error('Error fetching ballot details', error);
        this.loading = false;
      }
    );
  }

  generateBallotInternalHistory(
    detail: IIecBallotSummary | null
  ): IBallotInternalHistory[] {
    if (!detail) {
      return [];
    }

    const name =
        detail.finalisedByName?.trim() ||
        detail.finalisedByEmail?.trim() ||
        '-';

    return [
      {
        name,
        status: 'Finalised',
        date: detail.finalisedTime ? new Date(detail.finalisedTime) : null,
        comments: '',
      },
    ];
  }

  refreshIECBallot(ballotId: string) {
    this.ngOnInit();
  }
}
